import { env } from '@/config/env';
import type { RegisterRecord, StatusTone } from './api';

/** The register whose open records run the PDPA 72-hour clock. */
const BREACH_KIND = 'breach_response';
/** Made-up records are named "(demo)" (staging and training data). */
const DEMO = /\(demo\)/i;

/**
 * Review: only outside production, and only by the record's title (never its
 * free-text fields): a real breach never loses its clock.
 */
function isDemo(r: RegisterRecord, appEnv: string) {
  return appEnv !== 'production' && DEMO.test(r.title);
}

/**
 * RL-1828 (gap #150): outside production, a breach titled "(demo)" does not run the 72-hour
 * clock: no due time, never late, and an open one reads "Demo record: no
 * 72-hour clock" instead of "72-hour clock running". Real breaches unchanged.
 */
export function withoutDemoClock<T extends RegisterRecord>(
  r: T,
  appEnv: string = env.appEnv,
): T {
  if (r.kind !== BREACH_KIND || !isDemo(r, appEnv)) return r;
  return {
    ...r,
    dueAt: null,
    overdue: false,
    ...(r.status === 'open'
      ? {
          statusLabel: 'Demo record: no 72-hour clock',
          statusTone: 'neutral' as StatusTone,
        }
      : {}),
  };
}
